// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-constructor--info .page-constructor__body>section[data-v-6ca55c5f]:first-child{margin-top:0}.page-constructor--info .page-constructor__body>section[data-v-6ca55c5f]:last-child{margin-bottom:180px}@media(max-width:1279px){.page-constructor--info .page-constructor__body>section[data-v-6ca55c5f]:last-child{margin-bottom:120px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
